<script setup lang="ts">
import { ScreenSizeIndicator, ToastList, RouterView, useRoute, viewportSize } from '@hfc/ui-core';
import { appConfig } from '../AppConfig';
import { computed } from 'vue';
import { useAppStore } from '@/shared/infrastructure/composition/useAppStore';

const { appStore, appState } = useAppStore();

const route = useRoute();
const { viewport } = viewportSize();

const showIndicator = computed(() => appConfig.screenIndicator);
const layoutClass = computed(() => route.meta.layoutClass ? route.meta.layoutClass : 'max-w-7xl');
const headerClass = computed(() => {
  const w = viewport.value.width;
  let widthClass = 'max-w-[1280px]';
  if (w >= 1280 && w <= 1536) {
    widthClass = 'max-w-4xl';
  }

  return `${widthClass} ${viewport.value.width > 1280 ? 'px-0 sm:px-0' : ''}`;
});
</script>

<template>
  <div class="min-h-screen bg-blue-100 flex flex-col">
    <div class="sticky z-50 top-0 min-h-[112px]">
      <the-heading hide-navigation hide-search hide-quote-button :header-content-class="headerClass">
        <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
        <h2 v-if="appState.customTitle && appState.customTitleSlot === 'title'" slot="title" class="ml-2 -mt-2 flex-grow text-right text-xl xl:text-2xl 3xl:text-3xl flex justify-end items-center" :class="[appState.customTitleClass]">{{ appState.customTitle }}</h2>
        <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
        <div v-if="appState.customTitle && appState.customTitleSlot === 'content'" slot="content" class="flex w-full items-center justify-center lg:mr-28">
          <h2 class="text-right text-lg md:text-xl xl:text-2xl 3xl:text-3xl" :class="[appState.customTitleClass]">{{ appState.customTitle }}</h2>
        </div>
      </the-heading>
    </div>
    <div id="enrollment" class="flex flex-col w-full min-h-[calc(100vh-112px)] flex-grow mx-auto px-3 sm:px-6 lining-nums" :class="layoutClass">
      <ToastList v-if="appState.toastList.length > 0" :toast-list="[...appState.toastList]" @remove-error="(i: number) => appStore.removeErrorByIndex(i)" :offset-top="100" />
      <router-view />
      <ScreenSizeIndicator v-if= "showIndicator" />
    </div>
    <the-footer v-if="appState.showFooter" />
  </div>
</template>
